import apiClient, { API_ENDPOINTS, appendPath, rejectWithError } from "api";
import { normalizePrimaryIdCriteria } from "domains/commerce/services/cartRequestBuilders";

const { cart, order } = API_ENDPOINTS;

const rejectCartError = (error, label) => rejectWithError(error, label);

export const loadCartProducts = (criteria) => async () => {
  try {
    return await apiClient.post(cart.getCartItemsByCriteria, normalizePrimaryIdCriteria(criteria));
  } catch (error) {
    return rejectCartError(error, "Error loading cart products");
  }
};

export const deleteShoppingCart = async (id) => {
  try {
    await apiClient.delete(appendPath(cart.deleteShoppingCart, id));
    return undefined;
  } catch (error) {
    return rejectCartError(error, "Error deleting shopping cart");
  }
};

export const emptyCart = async (payload) => {
  try {
    return await apiClient.post(cart.emptyCart, payload);
  } catch (error) {
    return rejectCartError(error, "Error emptying cart");
  }
};

export const updateCartProducts = async (shoppingCart) => {
  try {
    return await apiClient.post(cart.updateCartProducts, shoppingCart);
  } catch (error) {
    return rejectCartError(error, "Error updating cart products");
  }
};

export const createOrder = async (orderReq) => {
  try {
    return await apiClient.post(order.createOrder, orderReq);
  } catch (error) {
    return rejectCartError(error, "Error creating order");
  }
};

export const updateOrder = async (orderReq) => {
  try {
    return await apiClient.post(order.updateOrder, orderReq);
  } catch (error) {
    return rejectCartError(error, "Error updating order");
  }
};

export const removeShoppingCartItem = async (shoppingCartData) => {
  try {
    return await apiClient.post(cart.removeShoppingCartItem, shoppingCartData);
  } catch (error) {
    return rejectCartError(error, "Error removing cart item");
  }
};

export const getShoppingCartItems = async (shoppingCartId) => {
  try {
    return await apiClient.post(cart.loadCartProducts, normalizePrimaryIdCriteria(shoppingCartId));
  } catch (error) {
    return rejectCartError(error, "Error getting shopping cart items");
  }
};

export const deleteShoppingCartById = async (id) => {
  try {
    await apiClient.delete(appendPath(cart.deleteShoppingCart, id));
    return undefined;
  } catch (error) {
    return rejectCartError(error, "Error deleting shopping cart by id");
  }
};
